import makeStyles from '@material-ui/core/styles/makeStyles';
var useStyles = makeStyles({
    container: {
        textDecoration: 'none',
    },
}, { name: 'TournamentLink' });
export { useStyles };
